// extracted by mini-css-extract-plugin
module.exports = {"noDataCard":"ManageDonationsPageView_noDataCard__bTGmX","addButton":"ManageDonationsPageView_addButton__3JPSg"};